import type { MapInteractiveWrapperProps } from "./map-interactive.type";

import { Spin } from "antd";

import { useElementSize } from "@/utilities/element";

import MapInteractive from "./map-interactive.component";
import { useMapStyle } from "./map-interactive.hook";

import "./map-interactive.style.less";

const MapInteractiveWrapper = ({
  loading = false,
  sizes,
  ...props
}: MapInteractiveWrapperProps) => {
  const style = useMapStyle(sizes);

  const { ref: mapContainerRef, size: mapSize } = useElementSize();
  const mapHasSize = mapSize?.width && mapSize?.height ? true : false;

  return (
    <div className="map-interactive-wrapper" style={style}>
      <div className="map-content" ref={mapContainerRef}>
        {loading ? (
          <Spin size="large" />
        ) : mapHasSize ? (
          <MapInteractive {...props} />
        ) : null}
      </div>
    </div>
  );
};

export default MapInteractiveWrapper;
